import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import RadioButton from '@amzn/meridian/radio-button';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import { setJobFormData } from 'src/store/createNewJobSlice';
import { useAppSelector } from 'src/store/store';
import { createSearchRegExp } from 'src/utils/searchUtils';

const JobSiteInfoFields = () => {
  const dispatch = useDispatch();
  const { specificSites, siteTypes, jobFormData, jobFormErrors } = useAppSelector((state) => state.createNewJobPage);
  const [siteTypeSearchQuery, setSiteTypeSearchQuery] = useState();
  const [applicableSitesSearchQuery, setApplicableSitesSearchQuery] = useState();

  const siteTypeSearchRegExp = createSearchRegExp(siteTypeSearchQuery);
  const applicableSitesSearchRegExp = createSearchRegExp(applicableSitesSearchQuery);

  const matchedSiteTypeOptions = siteTypes
    .map((siteTypes) => ({ label: siteTypes.label, value: siteTypes.label }))
    .filter((option) => !siteTypeSearchQuery || siteTypeSearchRegExp.test(option.label));
  const matchedApplicableSitesOptions = specificSites
    .map((site) => ({ label: site.site, value: site.site }))
    .filter((option) => !applicableSitesSearchQuery || applicableSitesSearchRegExp.test(option.label));

  return (
    <div>
      <Text type="h300">Job Site Information</Text>
      <Row widths={'fill'} spacingInset={'400 none 300 none'}>
        <Text>Job Applicability</Text>
      </Row>
      {jobFormErrors?.jobApplicability?.error && (
        <Row widths={'fill'} spacingInset={'100 none 100 none'}>
          <Text type="b200" color="error" className="create-new-job__content__add-task-subtitle">
            {jobFormErrors.jobApplicability?.errorMessage}
          </Text>
        </Row>
      )}
      <Row widths={'fill'} spacingInset={'300 none'}>
        <Column>
          <RadioButton
            checked={jobFormData?.jobApplicability === 'siteType'}
            onChange={(jobApplicability) => {
              dispatch(setJobFormData({ ...jobFormData, jobApplicability }));
            }}
            value="siteType"
          >
            <Text id="site-type-radio-value">Site Type</Text>
          </RadioButton>
          <Select
            aria-labelledby="site-type-radio-value"
            searchQuery={siteTypeSearchQuery}
            onSearch={setSiteTypeSearchQuery}
            placeholder="Enter site type..."
            value={jobFormData?.jobApplicability === 'siteType' ? jobFormData?.siteType : ''}
            disabled={jobFormData?.jobApplicability !== 'siteType'}
            onChange={(siteType) => {
              dispatch(
                setJobFormData({
                  ...jobFormData,
                  siteType,
                }),
              );
            }}
            error={jobFormErrors?.jobApplicability?.error}
          >
            {matchedSiteTypeOptions.map((option) => (
              <SelectOption label={option.label} value={option.value} key={option.value} />
            ))}
            {!matchedSiteTypeOptions.length ? (
              <Column alignmentVertical="center" spacing="300" spacingInset="500">
                <Text alignment="center">No results</Text>
              </Column>
            ) : null}
          </Select>
        </Column>
        <Column>
          <RadioButton
            checked={jobFormData?.jobApplicability === 'siteSpecific'}
            onChange={(jobApplicability) => {
              dispatch(setJobFormData({ ...jobFormData, jobApplicability }));
            }}
            value="siteSpecific"
          >
            Site Specific
          </RadioButton>
          <Select
            searchQuery={applicableSitesSearchQuery}
            onSearch={setApplicableSitesSearchQuery}
            placeholder={jobFormData?.region ? 'Enter specific sites...' : 'Select a region first'}
            disabled={jobFormData?.jobApplicability !== 'siteSpecific' || !jobFormData.region}
            value={jobFormData?.jobApplicability === 'siteSpecific' ? jobFormData?.applicableSites : ''}
            onChange={(applicableSites) => {
              dispatch(
                setJobFormData({
                  ...jobFormData,
                  applicableSites,
                }),
              );
            }}
            error={jobFormErrors?.jobApplicability?.error}
          >
            {matchedApplicableSitesOptions.map((option) => (
              <SelectOption label={option.label} value={option.value} key={option.value} />
            ))}
            {!matchedApplicableSitesOptions.length ? (
              <Column alignmentVertical="center" spacing="300" spacingInset="500">
                <Text alignment="center">No results</Text>
              </Column>
            ) : null}
          </Select>
        </Column>
      </Row>
      <Row widths={'fill'} spacingInset={'300 none 300 none'}>
        <Column spacing={'300'}>
          <Text tag="label">Job Type</Text>
          {jobFormErrors?.jobType?.error && (
            <Text type="b200" color="error" className="create-new-job__content__add-task-subtitle">
              {jobFormErrors.jobType?.errorMessage}
            </Text>
          )}
          <ButtonGroup
            value={jobFormData?.jobType}
            onChange={(jobType) => {
              dispatch(
                setJobFormData({
                  ...jobFormData,
                  jobType,
                }),
              );
            }}
          >
            <ButtonOption value="Process Path">Process Path</ButtonOption>
            {!jobFormData.isForTierTwoPlusRoles && <ButtonOption value="TLD Assignment">TLD Assignment</ButtonOption>}
          </ButtonGroup>
        </Column>
      </Row>
      <Divider spacingAfter={'500'} spacingBefore={'450'} />
    </div>
  );
};

export default JobSiteInfoFields;
